import { createSlice } from '@reduxjs/toolkit';

interface CreditState {
  amount: number;
}

const initialState: CreditState = {
  amount: 0,
};

export const selectCreditAmount = (state: any) => state.credits.amount;

export const creditSlice = createSlice({
  name: 'credits',
  initialState,
  reducers: {
    setCreditAmount: (state, action) => {
        state.amount = action.payload;
    },
  }
});

export default creditSlice.reducer;